const url = window.location.href;

/* ========= RELATED PRODUCTS & SPARE PARTS ========= */
if (url.includes("/products/")) {
  // Custom script built to evaluate related products & spare parts
  // Using `all_products` is much easier, however it has a max of 20 products
  // The following removes the limit and gives flexibility for how products are shown

  const updateInnerHTML = (container, image, title, url) => {
    if (image !== null) {
      document.getElementById(
        container
      ).innerHTML = `<a href="${url}" target="_blank" title="${title}">
    <img src="${image}&width=100" alt="${title}" /></a>`;
    } else {
      document.getElementById(
        container
      ).innerHTML = `<a href="${url}" target="_blank" title="${title}">${title}</a>`;
    }
  };

  // API call which searches for product info based on HANDLE
  // Product API Reference: https://shopify.dev/docs/themes/ajax-api/reference/product
  const getProductsByTitle = () => {
    const shopifyUrl = `https://atlanta-hobby.myshopify.com/products/`;
    let products = document.querySelectorAll('[id^="rp_"]');

    for (const product of products) {
      let container = product.id;
      // strip "rp_" from ID and pass along as HANDLE
      let handle = container.substring(3);

      fetch(`${shopifyUrl}${handle}.js`)
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          } else {
            return response.json();
          }
        })
        .then((data) => {
          updateInnerHTML(container, data.featured_image, data.title, data.url);
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  };

  getProductsByTitle();
}

/* ========= Custom code by Craft & Code ========= */
// This code will sort products in a collection based on inventory quantity
// Disabled for now, as we are using a plugin to sort products in collections
// This code is left here for future reference

// if (url.includes("/collections/")) {
//   // Sort products in collection based on inventory quantity
//   // Collections max at 50 products
//   // This script will organize all products loaded on a collection page
//   function sortCollectionByInventory() {
//     Array.prototype.slice
//       .call(document.querySelectorAll("ul#product-grid > li[data-inventory]"))
//       .sort(function (a, b) {
//         a = a.getAttribute("data-inventory");
//         b = b.getAttribute("data-inventory");

//         return Number(b) - Number(a);
//       })
//       .forEach(function (node) {
//         node.parentNode.appendChild(node);
//       });
//   }

//   // Call on initial page load
//   sortCollectionByInventory();

//   // Call function again when paginate button is used
//   // Timeout needed to make sure products are loaded before sorting
//   for (let element of document.getElementsByClassName("js-paginate-btn")) {
//     element.onclick = setTimeout(sortCollectionByInventory, 300);
//   }
// }
